import { Command, EditorState, Transaction, Selection } from "prosemirror-state";
import {FormEnvironment} from "@fd/Types.ts";
import {UiCommand} from "@fd/editors/html/EditorSupport.ts";
import {FormDefinition} from "@t/fd/layout/FormDefinition.ts";
import {CustomPart} from "@t/fd/CustomPart.ts";
import ImageSelector from "@fd/editors/html/components/ImageSelector.vue";
import { markRaw } from "vue";
import {InterfaceRoot} from "@t/fd/InterfaceRoot.ts";


export interface ImageData {
	src: string;
	alt: string;
	width?: number;
	height?: number;
}


export function insertImageCommand(env:FormEnvironment):UiCommand<ImageData> {
	return {
		extract(state): ImageData {
			return {
				src: "",
				alt: "",
				width: 0,
				height: 0
			};
		},

		form: <InterfaceRoot<FormDefinition>> {
			type: "interface",
			version: 2,
			lists: {},
			categories: {},
			define: {},
			methods: {},
			content: <FormDefinition>{
				type: "form",
				headerIcon: "insert-image",
				headerTitle: env.msg("insert.image"),
				body: markRaw(<CustomPart>{
					type: "custom",
					component: ImageSelector
				}),
				initialWidth: 440
			}
		},

		prepare(data: ImageData, savedSelection?:any):Command {
			return (state: EditorState, dispatch?: (tr: Transaction) => void) => {
				const { schema } = state;

				const attrs:{ [key:string]:any } = { src:data.src, alt:data.alt, title:data.alt };
				if (data.width) attrs.width = data.width;
				if (data.height) attrs.height = data.height;

				const imageNode = schema.nodes.image.create(attrs);

				const tr = state.tr;
				let from:number, to:number;
				if (savedSelection) {
					const s = Selection.fromJSON(tr.doc, savedSelection);
					tr.setSelection(s);
					from = s.from;
					to = s.to;
				} else {
					from = state.selection.from;
					to = state.selection.to;
				}
				tr.replaceWith(from, to, imageNode);

				if (dispatch) {
					dispatch(tr.scrollIntoView());
				}
				return true;
			};
		}
	};

}